import * as t from "./types";

class Endpoints {
  static readonly registerTraining = "/api/register_training";
  static readonly registerEvent = "/api/register_event";
  static readonly unregister = "/api/unregister";
  static readonly getSchedule = "/api/get_schedule";
  static readonly getCourses = "/api/get_courses";
  static readonly getEventInfo = "/api/get_event_info";
  static readonly getTrialSchedule = "/api/trials/schedule";
  static readonly registerTrial = "/api/trials/register";
}

export const apiPost = (url: string, data: object, callback: any) => {
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((response) => response.json());
};

export const apiGet = (url: string) => {
  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).catch(err => {
    console.error("err before json?");
    console.error(err);
    return undefined
  }).then((response) => {
    return response?.json();
  });
};

// so, really should do all the logic here, if it was successful or not, etc.
// then pass new courses, and any error info if necessary
export const registerForTraining = (courseid: number, name: string) => {
  // console.log(`registering for course ${courseid}`);
  return apiPost(
    Endpoints.registerTraining,
    {courseid: courseid, name: name},
    () => {}
  );
};

/**
 * execute request against the api to try and register for the specified event-course
 *
 * @param {t.IEventRegistration} reg - attempted registration data
 * @return any request response
 */
export const registerForEvent = (reg: t.IEventRegistrationData) => {
  return apiPost(Endpoints.registerEvent, reg, () => {});
};

export const unregister = (reg: t.ITrainingRegistration) => {
  console.log("reg: ");
  console.log(reg);
  return apiPost(Endpoints.unregister, reg, () => {});
};

export const unregisterForTraining = (courseid: number, name: string) => {
  // console.log("unregistering for course", courseid, name);
  return apiPost(
    Endpoints.unregister,
    {courseid: courseid, name: name},
    () => {}
  );
};

//here it should really be the same
export const getCourses = () => {
  return apiGet(Endpoints.getCourses);
};

export const getSchedule = () => {
  return apiGet(Endpoints.getSchedule);
};

export const getEventInfo = (id: number) => {
  return apiGet(`${Endpoints.getEventInfo}/${id}`);
};

export const getTrialSchedule = () => {
  return apiGet(
    Endpoints.getTrialSchedule
  ) as Promise<t.ITrialScheduleResponse>;
};
export const registerForTrial = (reg: t.ITrialRegistrationRequest) => {
  return apiPost(Endpoints.registerTrial, reg, () => {});
};
